export const num = (v) => {
  const n = parseFloat(v);
  return isNaN(n) ? 0 : n;
};

export const formatEuro = (value) =>
  new Intl.NumberFormat("fr-FR", { maximumFractionDigits: 0 }).format(
    Math.round(value)
  ) + " €";

export const formatCompactEuro = (value) => {
  const abs = Math.abs(value);
  if (abs >= 1000000) {
    return (
      new Intl.NumberFormat("fr-FR", { maximumFractionDigits: 2 }).format(
        value / 1000000
      ) + " M€"
    );
  }
  if (abs >= 10000) {
    return (
      new Intl.NumberFormat("fr-FR", { maximumFractionDigits: 1 }).format(
        value / 1000
      ) + " k€"
    );
  }
  return formatEuro(value);
};

export const formatPct = (value) =>
  new Intl.NumberFormat("fr-FR", { maximumFractionDigits: 1 }).format(value) +
  " %";

export const formatKm = (value) => {
  const v = num(value);
  return v >= 1000 ? Math.round(v / 1000) + "k" : String(v);
};
